import { createFileRoute } from '@tanstack/react-router';
import { ImportsRouteView } from '@/pages/workspaces/imports/routing';
import { LastWorkspaceResolver } from './-components';
import { validateWizardSearch } from './-import-wizard-search';
import { ImportPreprocessingPage } from './-route-pages';

/** No `appBundle`: this URL has no `journeys` segment for the resolver to rebuild from. */
function ImportPreprocessingRoute() {
  return (
    <LastWorkspaceResolver>
      <ImportsRouteView>
        <ImportPreprocessingPage />
      </ImportsRouteView>
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/imports/$importId/setup/preprocessing')({
  validateSearch: validateWizardSearch,
  component: ImportPreprocessingRoute,
});
